import { renderChipsAsMarkdownLinks, type ChipToken } from "./chips";

const MARKDOWN_CITATION_PATTERN = /\[\^([A-Za-z0-9_-]+)\]/g;

export const collectMarkdownCitationNoteIds = (markdown: string): string[] => {
  const noteIds = new Set<string>();
  let match: RegExpExecArray | null;

  MARKDOWN_CITATION_PATTERN.lastIndex = 0;
  while ((match = MARKDOWN_CITATION_PATTERN.exec(markdown)) !== null) {
    noteIds.add(match[1]);
  }

  return [...noteIds];
};

export const renderMarkdownBlockPreviewBody = ({
  body,
  resolveChipTitle,
}: {
  body: string;
  resolveChipTitle: (chip: ChipToken) => string | undefined;
}): string => {
  const bodyWithoutCitationMarkers = body.replace(MARKDOWN_CITATION_PATTERN, "");

  return renderChipsAsMarkdownLinks(bodyWithoutCitationMarkers, resolveChipTitle);
};
